module.exports = __webpack_public_path__ + "img/language_white_24dp.9dc52da9.svg";